import { render, staticRenderFns } from "./ElLoader.vue?vue&type=template&id=edb48b12&scoped=true&"
import script from "./ElLoader.vue?vue&type=script&lang=js&"
export * from "./ElLoader.vue?vue&type=script&lang=js&"
import style0 from "./ElLoader.vue?vue&type=style&index=0&id=edb48b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb48b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edb48b12')) {
      api.createRecord('edb48b12', component.options)
    } else {
      api.reload('edb48b12', component.options)
    }
    module.hot.accept("./ElLoader.vue?vue&type=template&id=edb48b12&scoped=true&", function () {
      api.rerender('edb48b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/elements/ElLoader.vue"
export default component.exports